/**
 * @generated SignedSource<<2a03f0e3dc9c3c4d833449a6c0fdc0bb>>
 * @relayHash 89e7485d3edde6bb1e8cde0055bac0c7
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 89e7485d3edde6bb1e8cde0055bac0c7

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amendment"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "brokerage"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ccnId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ccnVersion"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contractDescription"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "duplicata"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offerType"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "postCode"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propositionId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "staff"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tariffStructure"
},
v11 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "amendment",
        "variableName": "amendment"
      },
      {
        "kind": "Variable",
        "name": "brokerage",
        "variableName": "brokerage"
      },
      {
        "kind": "Variable",
        "name": "ccnId",
        "variableName": "ccnId"
      },
      {
        "kind": "Variable",
        "name": "ccnVersion",
        "variableName": "ccnVersion"
      },
      {
        "kind": "Variable",
        "name": "contractDescription",
        "variableName": "contractDescription"
      },
      {
        "kind": "Variable",
        "name": "duplicata",
        "variableName": "duplicata"
      },
      {
        "kind": "Variable",
        "name": "offerType",
        "variableName": "offerType"
      },
      {
        "kind": "Variable",
        "name": "postCode",
        "variableName": "postCode"
      },
      {
        "kind": "Variable",
        "name": "propositionId",
        "variableName": "propositionId"
      },
      {
        "kind": "Variable",
        "name": "staff",
        "variableName": "staff"
      },
      {
        "kind": "Variable",
        "name": "tariffStructure",
        "variableName": "tariffStructure"
      }
    ],
    "concreteType": "IsMedicalCheckRequiredMutationResponse",
    "kind": "LinkedField",
    "name": "isMedicalCheckRequired",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "medicalCheck",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "IsMedicalCheckRequiredMutation",
    "selections": (v11/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v8/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v9/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Operation",
    "name": "IsMedicalCheckRequiredMutation",
    "selections": (v11/*: any*/)
  },
  "params": {
    "id": "89e7485d3edde6bb1e8cde0055bac0c7",
    "metadata": {},
    "name": "IsMedicalCheckRequiredMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "3cc372562c20ed3905e839cfbcd19a26";

export default node;
